import BootstrapVue from "bootstrap-vue-3";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Importer le service analytics en premier pour initialiser les flags de blocage
import '@/services/analytics';

import "bootstrap/dist/css/bootstrap.css";
import vueDebounce, { PluginConfig } from "vue-debounce";
import "moment/locale/fr-ca";

const app = createApp(App);

app.use(BootstrapVue);
app.use<PluginConfig>(vueDebounce, {
  defaultTime: "500ms",
  listenTo: "keyup",
});


//app.use(VueMoment);

app.use(router);
app.mount("#app");
